// Official profiles of Ruxandra Sterbet (same URLs in both languages — same entity)
export const SOCIAL_LINKS = {
  linkedin: 'https://www.linkedin.com/in/ruxandra-sterbet-09b43b17a/',
  instagram: 'https://www.instagram.com/ruxandrasterbet/',
};

export const socialAria = (network, language) =>
  language === 'en' ? `Ruxandra Sterbet on ${network}` : `Ruxandra Sterbet pe ${network}`;
